import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './DateRangePicker.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      ref: "date-picker",
      staticClass: "date-picker",
      on: {
        click: function($event) {
          $event.stopPropagation();
        }
      }
    },
    [
      _c(
        "TextField",
        {
          attrs: {
            "is-focused": _vm.focused,
            "is-loading": _vm.isLoading,
            disabled: _vm.isLoading,
            "is-invalid": _vm.isInvalid,
            select: ""
          },
          on: { mousedown: _vm.toggle }
        },
        [
          _c("div", { staticClass: "input-from-wrapper" }, [
            _c("span", { staticClass: "input-from-ghost" }, [
              _vm._v(
                _vm._s(_vm.formattedDateFrom || "e.g. " + _vm.placeholderDate)
              )
            ]),
            _vm._v(" "),
            _c(
              "input",
              _vm._g(
                {
                  ref: "input-from",
                  staticClass: "input-from",
                  attrs: {
                    type: "text",
                    placeholder: "e.g. " + _vm.placeholderDate,
                    disabled: _vm.isLoading
                  },
                  domProps: { value: _vm.formattedDateFrom },
                  on: {
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.onEnter($event)
                    },
                    input: _vm.onInputFrom,
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape"
                        ])
                      ) {
                        return null
                      }
                      return _vm.onEsc($event)
                    },
                    focus: _vm.onFocus,
                    blur: _vm.onBlur
                  }
                },
                _vm.listeners
              )
            )
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("-")]),
          _vm._v(" "),
          _c(
            "input",
            _vm._g(
              {
                ref: "input-to",
                staticClass: "input-to",
                attrs: {
                  type: "text",
                  placeholder: _vm.placeholderDate,
                  disabled: _vm.isLoading
                },
                domProps: { value: _vm.formattedDateTo },
                on: {
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.onEnter($event)
                  },
                  input: _vm.onInputTo,
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "esc", 27, $event.key, [
                        "Esc",
                        "Escape"
                      ])
                    ) {
                      return null
                    }
                    return _vm.onEsc($event)
                  },
                  focus: _vm.onFocus,
                  blur: _vm.onBlur
                }
              },
              _vm.listeners
            )
          ),
          _vm._v(" "),
          _c("CalendarIcon", {
            staticClass: "icon",
            attrs: { size: "small", "disabled-range": _vm.disabledRange },
            nativeOn: {
              mousedown: function($event) {
                $event.preventDefault();
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Popup",
        {
          attrs: {
            "is-open": _vm.isOpen,
            "target-element": _vm.$refs["date-picker"],
            placement: "bottom-start"
          }
        },
        [
          _c(
            "div",
            { staticClass: "date-range" },
            [
              _c("Calendar", {
                attrs: {
                  value: _vm.dateRange,
                  "range-value": true,
                  "visible-date": _vm.visibleDate,
                  "time-zone": _vm.timeZone
                },
                on: { "date-selected": _vm.onDateSelected }
              }),
              _vm._v(" "),
              _vm.showQuickRanges
                ? _c(
                    "div",
                    { staticClass: "quick-ranges", attrs: { tabindex: "-1" } },
                    [
                      _c(
                        "DropdownGroup",
                        { attrs: { label: "Quick ranges" } },
                        [
                          _c(
                            "DropdownItem",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.onQuickRange("this-week")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        This week\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "DropdownItem",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.onQuickRange("this-month")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        This month\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "DropdownItem",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.onQuickRange("last-week")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        Last week\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "DropdownItem",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.onQuickRange("last-month")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        Last month\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "DropdownItem",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.onQuickRange("last-7days")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        Last 7 days\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "DropdownItem",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.onQuickRange("last-30days")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        Last 30 days\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "DropdownItem",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.onQuickRange("this-year")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        This year\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "DropdownItem",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.onQuickRange("last-year")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        Last year\n                    "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-b45995d0";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Calendar/DateRangePicker.vue.js